import { types } from '../../types/types';
import { HCE_ESTADOS, MENU_HCE, STEPPER_HCE_FORM } from '../../utils/constants';
import { remplazarPorTildeASinTilde, filter } from '../../helpers/Buscador';

const initialState = {
  items: [],
  hceSeleccionada: [],
  dataAfiliado: [],
  documentacion: [],
  documentacionOdontologia: [],
  problemas: [],
  evoluciones: [],
  informes: [],
  protocolo: [],
  protocolos: [],
  protocolosAux: [],
  efectores: [],
  estadosProblemas: [],
  recordatorioP: [],
  recordatorioG: [],
  problemasOdontologia: [],
  evolucionesGeneralesOdontologia: [],
  evolucionesOdontologia: [],
  signosVitales: [],
  efectorMedico: [],
  relEfectorCMEspe: [],
  pisoConsultorio: [],
  turnoTeleconsulta: [],
  turnosProximos: [],
  pacientesEnSala: [],
  vacunas: [],
  medicacionActiva: [],
  autopercepcionAfi: null,
  informesOftalmologia: [],
  protocolosOftalmologiaAux: [],
  protocolosOftalmologia: [],
  estudiosSolicitados: [],
  estudiosMedicos: [],
  turnos: [],
  estadoTurnos: HCE_ESTADOS.SIN_CONFIRMAR.toString(),
  activeBreadcrumb: MENU_HCE.DESELECCIONAR,
  activeStep: STEPPER_HCE_FORM.RECLAMOS_INGRESO,
  activeStepEmpadronamiento: 0,
  loading: false,
};

export const hceReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.hceClearReducer:
      return {
        ...initialState,
      };
    case types.setActiveBreadcrumbHce:
      return {
        ...state,
        activeBreadcrumb: action.payload,
      };
    case types.hceSetStep:
      return {
        ...state,
        activeStep: action.payload,
      };
    case types.hceEmpadronamientoSetStep:
      return {
        ...state,
        activeStepEmpadronamiento: action.payload,
      };
    case types.reclamosUpdateEstadoTurnos:
      return {
        ...state,
        estadoTurnos: action.payload,
      };
    case types.listaTurnosSucess:
      return {
        ...state,
        items: action.payload,
      };
    case types.listaHcePaciente:
      return {
        ...state,
        items: action.payload,
      };
    case types.SetHceSeleccionada:
      return {
        ...state,
        hceSeleccionada: action.payload,
      };
    case types.setDataAfiliadoHCE:
      return {
        ...state,
        dataAfiliado: action.payload,
      };
    //DOCUMENTACION
    case types.documentacionHCEClean:
      return {
        ...state,
        documentacion: [],
      };
    case types.documentacionHCESucces:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.documentacionHCEInsert:
      return {
        ...state,
        documentacion: [...state.documentacion, action.payload],
      };
    case types.documentacionHCEEliminar:
      return {
        ...state,
        documentacion: state.documentacion.filter(
          (item) => item.idDocumentacionHCE !== action.payload,
        ),
      };
    case types.documentacionHCEError:
      return {
        ...state,
        documentacion: [],
      };
    //DOCUMENTACION ODONTOLOGIA
    case types.documentacionOdontoHCEClean:
      return {
        ...state,
        documentacionOdontologia: [],
      };
    case types.documentacionOdontoHCESucces:
      return {
        ...state,
        documentacionOdontologia: action.payload,
      };
    case types.documentacionOdontoHCEInsert:
      return {
        ...state,
        documentacionOdontologia: [
          ...state.documentacionOdontologia,
          action.payload,
        ],
      };
    case types.documentacionOdontoHCEEliminar:
      return {
        ...state,
        documentacionOdontologia: state.documentacionOdontologia.filter(
          (item) => item.idDocumentacionOdontologia !== action.payload,
        ),
      };
    case types.documentacionOdontoHCEError:
      return {
        ...state,
        documentacionOdontologia: [],
      };
    //DOCUMENTACION EMPADRONAMIENTO
    case types.documentacionEmpHCEClean:
      return {
        ...state,
        documentacion: [],
      };
    case types.documentacionEmpHCESucces:
      return {
        ...state,
        documentacion: action.payload,
      };
    case types.documentacionEmpHCEInsert:
      return {
        ...state,
        documentacion: [...state.documentacion, action.payload],
      };
    case types.documentacionEmpHCEEliminar:
      return {
        ...state,
        documentacion: state.documentacion.filter(
          (item) => item.idDocumentacionHCE !== action.payload,
        ),
      };
    case types.documentacionEmpHCEError:
      return {
        ...state,
        documentacion: [],
      };
    //PROBLEMAS
    case types.problemasAfiliadoSucces:
      return {
        ...state,
        problemas: action.payload,
      };
    case types.estadosProblemasSucces:
      return {
        ...state,
        estadosProblemas: action.payload,
      };
    //EVOLUCIONES
    case types.evolucionesAfiliadoSucces:
      return {
        ...state,
        evoluciones: action.payload,
      };
    //INFORMES
    case types.informesAfiliadoSucces:
      return {
        ...state,
        informes: action.payload,
      };
    case types.protocoloImagenesSucces:
      return {
        ...state,
        protocolos: action.payload,
      };
    case types.protocoloImagenesPorIdSucces:
      return {
        ...state,
        protocolo: action.payload,
      };
    case types.abmInformesSucces:
      return {
        ...state,
        loading: false,
        protocolos: action.payload,
        protocolosAux: action.payload,
      };
    case types.abmBuscarInformes:
      var itemsResults = state.protocolosAux.filter((n) =>
        filter(
          remplazarPorTildeASinTilde(n.nombreProfesional),
          remplazarPorTildeASinTilde(action.payload),
        ),
      );
      return {
        ...state,
        protocolos: itemsResults,
      };
    case types.ambEfectoresmedicosSucces:
      return {
        ...state,
        efectores: action.payload,
      };
    // RECORDATORIOS
    case types.recordatorioGeneralSucces:
      return {
        ...state,
        recordatorioG: action.payload,
      };
    case types.recordatorioPropioSucces:
      return {
        ...state,
        recordatorioP: action.payload,
      };
    //ODONTOLOGIA
    case types.evolucionGeneralOdontologiaSucces:
      return {
        ...state,
        evolucionesGeneralesOdontologia: action.payload,
      };
    case types.problemasOdontologiaSucces:
      return {
        ...state,
        problemasOdontologia: action.payload,
      };
    case types.evolucionOdontologiaSucces:
      return {
        ...state,
        evolucionesOdontologia: action.payload,
      };


    //SIGNOS VITALES
    case types.signosVitalesSuccess:
      return {
        ...state,
        signosVitales: action.payload,
      };
    case types.listaEfectorMedicoSucess:
      return {
        ...state,
        efectorMedico: action.payload,
      };
    case types.relacionEfectorCMEspeSucess:
      return {
        ...state,
        relEfectorCMEspe: action.payload,
      };
    case types.pisoConsultorioEfectorSucess:
      return {
        ...state,
        pisoConsultorio: action.payload,
      };
    //TELECONSULTA  
    case types.turnoTeleconsultaSucess:
      return {
        ...state,
        turnoTeleconsulta: action.payload,
      };
    case types.turnosProximosAfiliadoSucess:
      return {
        ...state,
        turnosProximos: action.payload,
      };
    case types.salaEsperaAfiliadosSuccess:
      return {
        ...state,
        pacientesEnSala: [...state.pacientesEnSala, action.payload],
      };
    //AUTOPERCEPCION AFILIADO
    case types.hceAutopercepcionAfiliadoGetSuccess:
      return {
        ...state,
        autopercepcionAfi: action.payload,
      };
    case types.hceAutopercepcionAfiliadoGetError:
      return {
        ...state,
        autopercepcionAfi: null,
      };
    case types.hceAutopercepcionAfiliadoClear:
      return {
        ...state,
        autopercepcionAfi: null,
      };
    case types.vacunasSuccess:
      return {
        ...state,
        vacunas: action.payload,
      };
    case types.medicacionActivaSuccess:
      return {
        ...state,
        medicacionActiva: action.payload,
      };
    case types.informesOftalmologiaActivaSuccess:
      return {
        ...state,
        informesOftalmologia: action.payload,
      };
    case types.protocolosOftalmologiaActivaSuccess:
      return {
        ...state,
        protocolosOftalmologia: action.payload,
        protocolosOftalmologiaAux: action.payload,
      };
    case types.abmBuscarInformesOftalmologia:
      itemsResults = state.protocolosOftalmologiaAux.filter((n) =>
        filter(
          remplazarPorTildeASinTilde(n.nombreInforme),
          remplazarPorTildeASinTilde(action.payload),
        ),
      );
      return {
        ...state,
        protocolosOftalmologia: itemsResults,
      };
    case types.estudiosSolicitadosSucess:
      return {
        ...state,
        estudiosSolicitados: action.payload,
      };
    case types.estudiosMedicosSucess:
      return {
        ...state,
        estudiosMedicos: action.payload,
      };
    case types.turnosAfiliadosSucess:
      return {
        ...state,
        turnos: action.payload,
      };
    case types.abmBuscarEstudiosMedicos:
      itemsResults = state.estudiosMedicos.filter((n) =>
        filter(
          remplazarPorTildeASinTilde(n.descripcion),
          remplazarPorTildeASinTilde(action.payload),
        ),
      );
      break;
    default:
      return state;
  }
};
